import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-registration-success-pane',
  standalone: true,
  template: `
    <div class="flex items-center justify-center min-h-screen">
      <div class="rounded-md bg-green-50 p-4 max-w-md w-full">
        <div class="flex flex-col items-center text-center">
          <div class="flex-shrink-0 mb-4">
            <svg
              class="h-8 w-8 text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
          <div>
            <h3 class="text-lg font-medium text-green-800 mb-2">
              Registration successful!
            </h3>
            <div class="text-sm text-green-700 mb-6">
              <p>
                Your account has been created and is pending admin approval. You
                will receive an email notification once your account is
                approved.
              </p>
            </div>
            <div>
              <button
                type="button"
                (click)="onGoToLogin()"
                class="bg-green-600 px-4 py-2 rounded-md text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600 transition-colors"
              >
                Go to Login
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class RegistrationSuccessPaneComponent {
  @Output() goToLogin = new EventEmitter<void>();

  onGoToLogin(): void {
    this.goToLogin.emit();
  }
}
